import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import Chip from 'Chip';
import errorBoundary from '@ifeng/errorBoundary';
import NewsTopic from '../../../../components/newsTopic';
import ContentTitle from '../../../../components/contentTitle';
import PicList from '../../../../components/picList';
import NewsList from '../../../../components/newsList';

class PitBox extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    render() {
        const {
            content: { pitTopic, pitTitle0, pitTitle1, pitList0, pitList1 },
        } = this.props;

        return (
            <div id="pitNewsList" className={styles.pit_box}>
                <Chip id="50072" type="struct" title="智库栏标题" groupName="智库栏" content={pitTopic}>
                    <NewsTopic />
                </Chip>
                <Chip
                    id="75077"
                    type="recommend"
                    title="智库栏头条"
                    groupName="智库栏"
                    content={pitTitle0}
                    translate="handleNewsContentData">
                    <ContentTitle />
                </Chip>
                <Chip
                    id="75078"
                    type="recommend"
                    title="智库栏新闻列表"
                    groupName="智库栏"
                    content={pitList0}
                    translate="handleVideoContentData"
                    translateOptions={{ index: 0 }}>
                    <PicList />
                </Chip>
                <Chip
                    id="75079"
                    type="recommend"
                    title="互娱有声书头条"
                    groupName="智库栏"
                    content={pitTitle1}
                    translate="handleNewsContentData">
                    <NewsList hasTitle isList />
                </Chip>
                <Chip
                    id="75080"
                    type="recommend"
                    title="互娱有声书新闻列表"
                    groupName="智库栏"
                    content={pitList1}
                    translate="handleNewsContentData">
                    <NewsList isList />
                </Chip>
            </div>
        );
    }
}

export default errorBoundary(PitBox);
